import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-confirm-screen',
  templateUrl: './confirm-screen.component.html',
  styleUrls: ['./confirm-screen.component.sass']
})
export class ConfirmScreenComponent implements OnInit {
  @Output() updatescreenview = new EventEmitter<any>();   
  @Output() updatepaymentview = new EventEmitter<any>();   
  @Input() screen;
  @Input() dataPay;
  @Input() paytext;
  @Input() confirmNum;
  @Input() paymentID;
  public allDate;
  public returnPage;
  constructor(private global:GlobalService) { }

  ngOnInit() {
    if(this.confirmNum==undefined||this.paymentID==undefined||this.paymentID==null||this.confirmNum==null){
      this.confirmNum=1234;
      this.paymentID=12345;
    }
    this.returnPage=this.dataPay.data.module;
    let fullDateNow = new Date();
    let actualDate= fullDateNow.getFullYear();
    let actualMonth:any=fullDateNow.getMonth()+1;
    let actualDay:any=fullDateNow.getDate();
    let actualHour:any= fullDateNow.getHours();
    let minutes:any=fullDateNow.getMinutes();
    if(minutes.toString().length==1)
    {minutes="0"+minutes.toString();}
    if(actualHour.toString().length==1)
    {actualHour="0"+actualHour.toString();}
    if(actualDay.toString().length==1)
    {actualDay="0"+actualDay.toString();}
    if(actualMonth.toString().length==1)
    {actualMonth="0"+actualMonth.toString();}  

    this.allDate= actualDate+"-"+actualMonth+"-"+actualDay+" "+actualHour+":"+minutes;
  }
  return(){
    if(this.global.validateSession()===true){
      this.updatescreenview.emit(3);
      this.updatepaymentview.emit(3);
    }
  }

}

